module.exports = __webpack_public_path__ + "02_face.f8e8fc38.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer1/02_face.png
// module id = SZ0x
// module chunks = 0